import { FieldFilterPicker, Filter, Override, StringHelper } from "@bryntum/schedulerpro";

const menuItemsWithSeparators = {
  filterDateIsToday     : true,
  filterDateIsThisWeek  : true,
  filterDateIsThisMonth : true,
  filterDateIsThisYear  : true
};

Override.apply(class {
  static target = {
    class: Filter,
    product: "schedulerpro"
  }

  getFilterType(column) {
    if (this.pickerConfig) {
      return this.pickerConfig.fields[column.field]?.type;
    }
    return this._overridden.getFilterType.call(this, ...arguments);
  }

  // Swivu Note: commenting out an if condition below which prevents filter menu to be opened from the column context menu
  getMenuItems(column, record) {
    const
      me = this,
      submenuItems = {},
      type = me.getFilterType(column);

    if (column.filterable === false) {
      return {};
    }

    // Swivu Note: This is the line that prevent filter menu to be open from the column right click context menu
    // if (allowedFilterTypes[type]) {
      const
        value = record ? column.getFilterableValue(record) : undefined,
        activeOperators = me.getCurrentMultiFilters(column)
          .filter(filter => !filter.disabled)
          .map(({ operator }) => operator),
        maxArgCount = record ? 1 : undefined,
        columnAllowedOperators =  me.getAllowedOperators(column),
        allowedOperators = FieldFilterPicker.defaultOperators[type]
          .filter(({ value, argCount, _isArrayValued }) =>
            !(argCount > maxArgCount) && // Swivu Note: removed _isArrayValued from this statement as this prevents includes/excludes array filters not to be included in column menu Filters list
            (!columnAllowedOperators || columnAllowedOperators.includes(value)));
      let weight = 300;
      for (const { value: operator, text, argCount } of allowedOperators) {
        const key = `filter${StringHelper.capitalize(type)}${StringHelper.capitalize(operator)}`;
        submenuItems[key] = {
          text     : StringHelper.capitalize(FieldFilterPicker.L(text)),
          weight   : weight += 10,
          icon     : activeOperators.includes(operator) ? 'b-icon b-icon-check' : null,
          disabled : me.disabled,
          cls      : menuItemsWithSeparators[key] ? 'b-separator' : null,
          onItem   : () => me.onOperatorMenuItem(column, value, operator, argCount)
        };
      }
    // }

    if (column.meta.isFiltered) {
      Object.assign(submenuItems, me.getMenuItemsForFilteredColumn(column, record !== undefined));
    }

    return {
      filterMenu : {
        text        : 'L{filter}',
        localeClass : me,
        menu        : submenuItems,
        icon        : 'b-fw-icon b-icon-filter',
        weight      : record ? 400 : 100
      }
    };
  }
})
